
<template>
  <v-card
    min-height="200"
    color="grey lighten-5"
    :hover="currSubStepInApi===1"
  >
    <v-card-title>
      <!-- list display START -->
      <template v-if="currSubStepInApi===1">
        <div
          class="headline primary--text"
          :class="{ 'grey--text': (!api.enabled) }"
        >
          <v-icon color="primary">
            {{ $appConfig.api.icon }}
          </v-icon> {{ api.name }}
        </div>
        <v-col cols="12">
          <div class="grey--text caption">
            Updated: {{ api.updated_at }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="subheading">
            {{ api.description }}
          </div>
        </v-col>
        <template v-for="(label,i) in api.labels">
          <v-chip
            :key="i"
            label
            outlined
          >
            {{ label.name }}
          </v-chip>
        </template>
        <template v-if="!api.labels.length">
          <v-chip
            label
            outlined
          >
            No label
          </v-chip>
        </template>
      </template>
      <!-- list display END -->

      <!-- selected api display START -->
      <template v-else>
        <div
          class="headline primary--text"
          :class="{ 'grey--text': (!trigger.source.enabled) }"
        >
          <v-icon color="primary">
            {{ $appConfig.api.icon }}
          </v-icon> {{ trigger.source.name }}
        </div>
        <v-col cols="12">
          <div class="grey--text caption">
            Updated: {{ trigger.source.updated_at }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="subheading">
            {{ trigger.source.description }}
          </div>
        </v-col>

        <template v-for="(label,i) in trigger.labels">
          <v-chip
            :key="i"
            label
            outlined
          >
            {{ label.name }}
          </v-chip>
        </template>
        <template v-if="!trigger.source.labels.length">
          <v-chip
            label
            outlined
          >
            No label
          </v-chip>
        </template>
      </template>
    </v-card-title>
    
    <v-card-text v-if="currSubStepInApi===2">
      <v-row>
        <v-col cols="6">
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              block
              :color="(currFetch==='PRE') ? 'primary' : ''"
              @click.native="buttonClicked('PRE')"
            >
              PRE
            </v-btn>
            <span> The function will be called BEFORE the API is called </span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              block
              :color="(currFetch==='POST') ? 'primary' : ''"
              @click.native="buttonClicked('POST')"
            >
              POST
            </v-btn>
            <span> The function will be called AFTER the API is called</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- selected api display END -->
  </v-card>
</template>

<script>
  export default {
    props: {
      api: {},
      index: Number,
      currSubStep: Number,
      currFetch: {
        type: String,
        default: '',
      },
      currRequest: {
        type: String,
        default: '',
      },
      trigger: {},
    },
    data () {
      return {
        clicked: Boolean,
        isNew: Boolean,
        currSubStepInApi: this.currSubStep,
        mytrigger: {},
      }
    },
    watch: {
      currSubStep: function () {
        this.currSubStepInApi = this.currSubStep
      },
      trigger: function () {
        this.mytrigger = this.trigger
      },
    },
    methods: {
      buttonClicked (choice) {
        this.$emit('buttonClicked', choice)
      },
    },
  }

</script>
